import React from "react";
import { SanityLandingPageHomePageIntro } from "../../model/landing-page";
import HomePageGetStartedBlock from "../HomePageGetStartedBlock/HomePageGetStartedBlock";
import HomePageMicrobitBlock from "../HomePageMicrobitBlock/HomePageMicrobitBlock";
import styles from "./HomePageIntro.module.scss";

interface HomePageIntroProps {
  value: SanityLandingPageHomePageIntro;
}

export const HomePageIntro = ({
  value: {
    bottomImage,
    callToActionLink,
    callToActionText,
    content,
    topImageDesktop,
    topImageMobile
  }
}: HomePageIntroProps) => (
  <>
    <section>
      <HomePageMicrobitBlock
        callToActionText={callToActionText}
        callToAction={callToActionLink}
        desktopImage={topImageDesktop}
        mobileImage={topImageMobile}
      />
    </section>
    <section className={styles.getStartedSection}>
      <HomePageGetStartedBlock content={content} image={bottomImage} />
    </section>
  </>
);
